import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ResourceQuery" }
const _hoisted_2 = { style: {"align-items":"center","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"margin-left":"10px"} }

import { ElMessage } from 'element-plus'
import { useStore } from '@/store'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getListData } from '@/service/main/system'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceQuery',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getCompanyList = async () => {
  const companyList = await getListData(
    '/main/enterpriseWechat/config/listAll',
    {}
  )
  const companyItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  companyItem!.options = companyList.map((item: any) => ({
    title: item.name,
    value: item.id
  }))
}

const getUsedBy = async () => {
  const userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userList.map((item: any) => ({
    title: item.userName,
    value: item.userName
  }))
}

const getThirdPartyList = async () => {
  const thirdPartyList = await getListData(
    '/main/customerChannel/queryThirdParty',
    {}
  )
  const thirdPartyItem = searchFormConfig.formItems.find(
    (item) => item.field === 'thirdParty'
  )
  thirdPartyItem!.options = thirdPartyList.map((item: string) => ({
    title: item,
    value: item
  }))
}

getCompanyList()
getUsedBy()
getThirdPartyList()

const getDefaultQuery = () => {
  if (store.state.login.userInfo.isManager != '1') {
    return { usedBy: store.state.login.userInfo.realName }
  }

  return {}
}

store.commit('system/changeQueyryInfo', getDefaultQuery())

const resetCb = () => getDefaultQuery()

const validateSearchParams = (params: any) => {
  const hasFilter = Object.values(params).some((value) => {
    if (Array.isArray(value)) {
      return value.some(
        (item) => item !== null && item !== undefined && item !== ''
      )
    }
    return value !== null && value !== undefined && value !== ''
  })

  if (!hasFilter) {
    ElMessage.warning('请至少选择一个筛选条件后再查询')
    return false
  }

  return true
}

const handleSearchClick = (formData: any) => {
  if (!validateSearchParams(formData)) return
  pageContentRef.value?.getSearchPageData(formData)
}

const [pageContentRef, handleResetClick, , handleDownBtnClick] =
  usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      labelWidth: "120px",
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "resourceQuery",
      pageUrl: "/main/customerStatistics/queryByConditionByNB",
      downUrl: "/main/customerStatistics/downloadNB",
      downFilename: "资源查询.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.uname) + " (" + _toDisplayString(scope.row.remark) + ") ", 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})